import "./Decor.css"
import Product1 from "../Components/Product1"

import Music1 from "../images/mi1.jpg"
import Music2 from "../images/mi2.jpg"
import Music3 from "../images/mi3.jpg"
import Music4 from "../images/mi4.jpg"
import Music5 from "../images/mi5.jpg"
import Music6 from "../images/mi6.jpg"
import Music7 from "../images/mi7.jpg"
import Music8 from "../images/mi8.jpg"
import Music9 from "../images/musicadd.jpg"
export default function Music() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Music9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="music1" prdName="Drum" img={ Music1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="music2"prdName="Tabla" img={ Music2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="music3"prdName="Guitar" img={ Music3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="music4" prdName="Voilin" img={ Music4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="music5"prdName="Hormoni" img={ Music5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="music6"prdName="Wireless_Guitar" img={ Music6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="music7"prdName="Mandolin" img={ Music7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="music8"prdName="Veena" img={ Music8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}